import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCalendlyUrl } from '../api/profileApi';
import type { ServiceProviderProfile } from '../api/profileApi';

/**
 * React Query hook for updating provider's Calendly URL (Feature 035)
 *
 * Automatically invalidates the provider profile cache on success
 *
 * @returns useMutation result with mutate function, loading state, and error
 */
export function useUpdateCalendlyUrl() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCalendlyUrl,
    onSuccess: (updatedProfile: ServiceProviderProfile) => {
      // Invalidate and refetch provider profile
      queryClient.invalidateQueries({ queryKey: ['provider', 'profile'] });

      // Optionally update the cache optimistically
      queryClient.setQueryData<ServiceProviderProfile>(
        ['provider', 'profile'],
        updatedProfile
      );
    },
  });
}
